<template>
  <v-container v-if="threeRandomReviews && threeRandomReviews.length">
    <TitleParagraphRow :value="value || { title: 'Customer Reviews' }" dense />

    <v-row justify="space-evenly">
      <v-col v-for="item in threeRandomReviews" :key="item.id" cols="12" md="4">
        <ReviewCard :value="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import type { components } from '#root/types/directus'
import type { WidgetReviewsSection } from '#root/types/widget-sections'
import { computed } from 'vue'

const props = defineProps<{
  items: components['schemas']['ItemsReviews'][]
  value: WidgetReviewsSection
}>()

const threeRandomReviews = computed(() => {
  return [...props.items].sort(() => Math.random() - 0.5).slice(0, 3)
})
</script>
